import { GroupFragment, IssueStatus, IssueType } from "@/generated/graphql";

export const issueTypes: IssueType[] = [IssueType.Milestone, IssueType.Task];

export const issueStatuses: IssueStatus[] = [
  IssueStatus.InProgress,
  IssueStatus.Completed,
  IssueStatus.Blocked,
  IssueStatus.NotStarted,
];

/**
 * Random Members for testing
 * USE THIS FOR STORIES USE-CASE ONLY
 */
export const TEST_ASSIGNEES: GroupFragment["members"] = [
  {
    colourset: 1,
    id: "42179b5a-4ca1-4e8b-8fde-0b3ebd56f668",
    name: "John Doe",
    email: null,
    givenName: "",
    familyName: "",
  },
  {
    colourset: 2,
    id: "e5f0ed1c-baf6-4817-84e3-d51b97673a07",
    name: "Jane Smith",
    email: null,
    givenName: "",
    familyName: "",
  },
  {
    colourset: 3,
    id: "e5f0ed1c-baf6-4817-84e3-d51b97673a06",
    name: "Alice Johnson",
    email: null,
    givenName: "",
    familyName: "",
  },
];
